import { Box, Typography } from '@mui/material';

interface EmptyStateProps {
  message: string;
  py?: number;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ message, py = 4 }) => (
  <Box display='flex' justifyContent='center' py={py}>
    <Typography variant='body2' color='text.secondary'>
      {message}
    </Typography>
  </Box>
);
